// ----------------------------------------------------------------------------
// Section: Banner
// ----------------------------------------------------------------------------

import 'snippets/video-player/video-block';
import './_banner-block.scss';